import { createI18n, type ComposerTranslation } from "vue-i18n"; //TODO: currently using beta to work with vite. Update if version 9.3 is released!
import { deDe } from "@/locales/de-de";
import { enEn } from "@/locales/en-en";
// eslint-disable-next-line vue/prefer-import-from-vue
import { Primitive } from "@vue/reactivity";

const messages = {
  "de-DE": deDe,
  "en-EN": enEn,
};

export let browserLanguage = "en-EN";
if (navigator.language == "de") {
  browserLanguage = "de-DE";
}

export const i18n = createI18n({
  legacy: false,
  locale: browserLanguage,
  fallbackLocale: "en-EN",
  messages: messages,
});

type TranslationsType = typeof deDe;

// ensures that nested keys are accessible with "."
type DotNotationEntries<T> = T extends object
  ? {
      [K in keyof T]: `${K & string}${T[K] extends undefined
        ? ""
        : T[K] extends object
        ? `.${DotNotationEntries<T[K]>}`
        : ""}`;
    }[keyof T]
  : "";

// enables both intellisense and new keys without an error
type LiteralUnion<LiteralType extends BaseType, BaseType extends Primitive> =
  | LiteralType
  | (BaseType & { _?: never });

export type TranslationKey =
  //  LiteralUnion<
  DotNotationEntries<TranslationsType>;
//, string>;
